var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconOther(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.06714 16.9921C1.06714 16.5736 1.41042 16.2344 1.82261 16.2344H6.37347C6.7907 16.2344 7.12894 16.5707 7.12894 16.9921C7.12894 17.4106 6.78566 17.7498 6.37347 17.7498H1.82261C1.40538 17.7498 1.06714 17.4135 1.06714 16.9921ZM7.88667 16.9921C7.88667 16.5736 8.21846 16.2344 8.64661 16.2344H12.4308C12.8505 16.2344 13.1907 16.5707 13.1907 16.9921C13.1907 17.4106 12.859 17.7498 12.4308 17.7498H8.64661C8.22691 17.7498 7.88667 17.4135 7.88667 16.9921ZM13.9485 16.9921C13.9485 16.5736 14.2839 16.2344 14.7054 16.2344H15.4647C15.8828 16.2344 16.2216 16.5707 16.2216 16.9921C16.2216 17.4106 15.8862 17.7498 15.4647 17.7498H14.7054C14.2874 17.7498 13.9485 17.4135 13.9485 16.9921Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.01823 12.9839L7.64995 12.4954L13.3692 6.77615C13.6535 6.49183 13.6484 6.01269 13.3497 5.714L12.2882 4.65246C11.9849 4.34919 11.5139 4.34505 11.226 4.63298L5.50678 10.3522L5.01823 12.9839ZM3.14317 14.859L4.12028 9.59554L10.1544 3.56139C11.0185 2.69728 12.435 2.71909 13.3283 3.61236L14.3898 4.67391C15.2785 5.56263 15.3012 6.98726 14.4408 7.84773L8.40662 13.8819L3.14317 14.859Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOther);
export default __webpack_public_path__ + "static/media/icon-other.ed33f5fcc3b72ca3d070dc5a5a9b34fc.svg";
export { ForwardRef as ReactComponent };